import React from 'react'
import { string, shape } from 'prop-types'
import styles from './SpeakerThumbnail.module.scss'
import Type from '@/component/Primitive/Type'
import ResponsiveImage from '@/component/Primitive/ResponsiveImage'
import cx from 'classnames'

export const SpeakerThumbnail = ({
  image,
  name,
  jobTitle,
  companyName,
  className,
  classNames
}) => {
  return (
    <div className={cx(styles.SpeakerThumbnail, className)}>
      <div className={styles.SpeakerThumbnailImageWrapper}>
        <ResponsiveImage className={styles.SpeakerThumbailImage} {...image} />
      </div>
      <div className={styles.SpeakerThumbnailContent}>
        <Type
          as="h3"
          size="body2"
          weight="medium"
          classNames={classNames?.name}
        >
          {name}
        </Type>
        <Type
          as="p"
          size="body4"
          className={cx(styles.SpeakerThumbnailJobTitle, classNames?.jobTitle)}
        >
          {jobTitle}, {companyName}
        </Type>
      </div>
    </div>
  )
}

SpeakerThumbnail.propTypes = {
  image: string,
  name: string,
  jobTitle: string,
  companyName: string,
  className: string,
  classNames: shape({
    name: string,
    jobTitle: string
  })
}
